import { Component, Input } from '@angular/core';
import { KPStandard } from 'src/app/constants/standard/kp.standard';
import { FlightConfigurationDto } from 'src/app/dto/flightConfiguration/flightConfiguration.dto';
import { UnitDto } from 'src/app/dto/unit/unit.dto';
import { KpInfoDto } from 'src/app/dto/weatherTable/kp/kpInfo.dto';
import { KpListDto } from 'src/app/dto/weatherTable/kp/kpList.dto';
import { FlightStatusCode, FlightStatusName } from 'src/app/dto/weatherTable/weather/flightStatus.code';
import { WeatherListDto } from 'src/app/dto/weatherTable/weather/weatherList.dto';
import { WeatherListItemDto } from 'src/app/dto/weatherTable/weatherListItem.dto';
import { DateService } from 'src/app/service/date/date.service';

@Component({
    selector: 'weather-table',
    templateUrl: '../../view/weatherTable/weatherTable.html'
})
export class WeatherTableComponent {
    private weatherListDto: WeatherListDto[] = [];
    public displayedWeatherList: WeatherListDto[] = [];
    public kpListDto: KpListDto[] = [];
    public displayedKpList: KpListDto[] = [];
    public currentSatelliteCount!: number;
    public flightConfiguration!: FlightConfigurationDto;
    public userUnit: UnitDto = new UnitDto();
    
    public kpStandard: typeof KPStandard = KPStandard;
    public flightStatusName: typeof FlightStatusName = FlightStatusName;
    public flightStatusCode: typeof FlightStatusCode = FlightStatusCode;

    public isVisibleTableDescription: boolean = false;
    public isVisibleList: boolean = true;
    public isContainedGust: boolean = false;
    public isOnlySunrise: boolean = false;

    @Input() public flightConfigurationDto!: FlightConfigurationDto;

    constructor(public dateService: DateService) {
    }

    public setWeatherList(weatherListDto: WeatherListDto[]): void {
        this.initWeatherListDto(weatherListDto);
        this.initDisplayedWeatherList();
    }

    private initWeatherListDto(weatherListDto: WeatherListDto[]): void {
        this.weatherListDto = [];

        for (let i = 0; i < weatherListDto.length; i++) {
            this.weatherListDto.push(Object.assign(new WeatherListDto(), weatherListDto[i]));
            this.weatherListDto[i].infos = [];

            for (let j = 0; j < weatherListDto[i].infos.length; j++) {
                this.weatherListDto[i].infos.push(Object.assign(new WeatherListItemDto(), weatherListDto[i].infos[j]));
            }
        }
    }

    private initDisplayedWeatherList(): void {
        this.displayedWeatherList = [];

        for (let i = 0; i < this.weatherListDto.length; i++) {
            let weatherListItem: WeatherListDto = Object.assign(new WeatherListDto(), this.weatherListDto[i]);
            weatherListItem.infos = [];

            
            let lastSunrise = this.weatherListDto[i].sunrise;
            let lastSunset = this.weatherListDto[i].sunset;

            for (let j = 0; j < this.weatherListDto[i].infos.length; j++) {
                if (this.isOnlySunrise) {
                    if (this.weatherListDto[i].infos[j].timeTag > lastSunrise && this.weatherListDto[i].infos[j].timeTag < lastSunset) {
                        weatherListItem.infos.push(Object.assign(new WeatherListItemDto(), this.weatherListDto[i].infos[j]));
                    }
                } else {
                    weatherListItem.infos.push(Object.assign(new WeatherListItemDto(), this.weatherListDto[i].infos[j]));
                }
            }

            if (weatherListItem.infos.length != 0) {
                this.displayedWeatherList.push(weatherListItem);
            }
        }
    }

    public setKpList(kpListDto: KpListDto[]): void {
        this.kpListDto = [];
        this.kpListDto = kpListDto;

        this.initDisplayedKpList();
    }

    private initDisplayedKpList(): void {
        this.displayedKpList = [];

        for (let i = 0; i < this.kpListDto.length; i++) {
            let kpListItem: KpListDto = Object.assign(new KpListDto(), this.kpListDto[i]);
            kpListItem.infos = [];

            let lastSunrise: string = this.weatherListDto[i]?.sunrise;
            let lastSunset: string = this.weatherListDto[i]?.sunset;
            
            for (let j = 0; j < this.kpListDto[i].infos.length; j++) {
                if (this.isOnlySunrise) {
                    if (this.kpListDto[i].infos[j].timeTag > lastSunrise && this.kpListDto[i].infos[j].timeTag < lastSunset) {
                        kpListItem.infos.push(Object.assign(new KpInfoDto(), this.kpListDto[i].infos[j]));
                    }
                } else {
                    kpListItem.infos.push(Object.assign(new KpInfoDto(), this.kpListDto[i].infos[j]));
                }
            }

            if (kpListItem.infos.length != 0) {
                this.displayedKpList.push(kpListItem);
            }
        }
    }

    public setCurrentSatelliteCount(currentSatelliteCount: number): void {
        this.currentSatelliteCount = currentSatelliteCount;
    }

    public setFlightConfiguration(flightConfigurationDto: FlightConfigurationDto): void {
        this.flightConfiguration = flightConfigurationDto;
    }

    public setUserUnit(unitDto: UnitDto): void {
        this.userUnit = Object.assign(new UnitDto(), unitDto);
    }

    public setContainedGust(isContainedGust: boolean): void {
        this.isContainedGust = isContainedGust;
    }

    public toggleListVisible(): void {
        this.isVisibleList = !this.isVisibleList;

        for (let i = 0; i < this.displayedWeatherList.length; i++) {
            this.displayedWeatherList[i].isVisible = this.isVisibleList;
        }
    }

    public toggleItemVisible(listItemIndex: number): void {
        this.displayedWeatherList[listItemIndex].isVisible = !this.displayedWeatherList[listItemIndex].isVisible;

        if (!this.displayedWeatherList[listItemIndex].isVisible) {
            this.isVisibleList = false;
        }

        if (this.isItemAllVisible()) {
            this.isVisibleList = true;
        }
    }

    private isItemAllVisible(): boolean {
        for (let i = 0; i < this.displayedWeatherList.length; i++) {
            if (!this.displayedWeatherList[i].isVisible) {
                return false;
            }
        }

        return true;
    }

    public toggleTableDescription(): void {
        this.isVisibleTableDescription = !this.isVisibleTableDescription;
    }

    public getDisplayedWeatherList(): WeatherListDto[] {
        if (this.displayedWeatherList) {
            return this.displayedWeatherList;
        }

        return this.getEmptyWeatherList();
    }

    private getEmptyWeatherList(): WeatherListDto[] {
        let emptyWeatherList: WeatherListDto[] = [];
        emptyWeatherList.push(new WeatherListDto());

        return emptyWeatherList;
    }

    public changeVisibleTime(): void {
        this.isOnlySunrise = !this.isOnlySunrise;

        this.initDisplayedWeatherList();
        this.initDisplayedKpList();
    }

    public getFlightStatusCode(listIndex: number, listItemIndex: number): FlightStatusCode {
        let resultCode: FlightStatusCode;

        if (listIndex == 0 && listItemIndex == 0) {
            resultCode = this.displayedWeatherList[listIndex].infos[listItemIndex].isPossibleFlightWithSatellite(this.flightConfiguration, this.currentSatelliteCount, this.isContainedGust);
        } else {
            resultCode = this.displayedWeatherList[listIndex].infos[listItemIndex].isPossibleFlight(this.flightConfiguration, this.isContainedGust);
        }

        if (this.displayedKpList[listIndex]?.infos[listItemIndex]?.kp >= KPStandard.DANGEROUS_KP) {
            resultCode = FlightStatusCode.DANGER;
        }

        return resultCode;
    }
}